import React, { useContext, useState, useEffect, useRef } from 'react'
import { Box, Button, Typography } from '@mui/material'

import { ReactComponent as AIicon } from '../../../common/icons/aiPower.svg'
import { PageNumberContext } from '../../../context/PageNumberContext'
import WrapperInfoCard from './InfoCards/WrapperInfoCard'
import FirstStepCard from './InfoCards/FirstStepCard'
import NavTabs from '../../../common/components/NavTabs'
import { Field, useForm } from 'react-final-form'

import AllMicroTrainingsField from './AllMicrotrainings/AllMicroTrainingsField'

export default function SecondPageForm({ values, initialValues }) {
  const { setPage, moduleType } = useContext(PageNumberContext)
  const form = useForm()
  const [activeTab, setActiveTab] = useState(0)
  const isInitialized = useRef(false)

  const isEditing = !!initialValues?.id

  const trainingModuleIds = Array.isArray(values?.trainingModuleIds) ? values.trainingModuleIds : []
  const customTrainingModuleIds = Array.isArray(values?.customTrainingModuleIds) ? values.customTrainingModuleIds : []

  const isModulesSelected = trainingModuleIds.length > 0
  const isCustomModulesSelected = customTrainingModuleIds.length > 0

  useEffect(() => {
    if (isInitialized.current) return
    isInitialized.current = true

    if (moduleType) {
      if (moduleType === 'CUSTOM_MODULES') {
        setActiveTab(1)
      } else {
        setActiveTab(0)
      }
    } else if (isEditing) {
      if (isCustomModulesSelected) {
        setActiveTab(1)
      } else {
        setActiveTab(0)
      }
    }
  }, [isEditing, isCustomModulesSelected, moduleType])

  useEffect(() => {
    form.change('type', activeTab === 0 ? 'MODULES' : 'CUSTOM_MODULES')
  }, [activeTab, form])

  const handleTabChange = (event, newTab) => {
    if (isEditing) {
      return
    }

    if (newTab === 1 && activeTab === 0) {
      form.change('trainingModuleIds', [])
    }

    if (newTab === 0 && activeTab === 1) {
      form.change('customTrainingModuleIds', [])
    }

    setActiveTab(newTab)
  }

  const tabsConfig = [
    {
      label: 'Modules',
      content: (
        <Field
          name='trainingModuleIds'
          render={({ input }) => <AllMicroTrainingsField input={input} type={'INTERNAL'} isEditing={isEditing} />}
        />
      ),
      value: 0,
      to: ``,
      disabled: isEditing && isCustomModulesSelected
    },
    {
      label: 'Custom modules',
      content: (
        <Field
          name='customTrainingModuleIds'
          render={({ input }) => <AllMicroTrainingsField input={input} type={'CUSTOM'} isEditing={isEditing} />}
        />
      ),
      value: 1,
      to: ``,
      disabled: isEditing && isModulesSelected
    }
  ]

  return (
    <Box display='flex' flexDirection='column' pt={3} rowGap={3} width='100%'>
      <Typography fontFamily={'Satoshi'} fontWeight={500} fontSize={'24px'} color={'#1B1B26'}>
        Training info
      </Typography>
      <WrapperInfoCard onChange={() => setPage(1)}>
        <FirstStepCard />
      </WrapperInfoCard>
      <Typography fontFamily={'Satoshi'} fontWeight={500} fontSize={'24px'} color={'#1B1B26'}>
        Includes Modules
      </Typography>
      <NavTabs tabItems={tabsConfig} activeTab={activeTab} onChange={handleTabChange} />
      <Box
        width='100%'
        display='flex'
        columnGap={2}
        justifyContent='space-between'
        sx={{ position: 'sticky', bottom: 0, background: 'transparent' }}
      >
        <Box sx={{ padding: '16px' }}>
          <Button sx={{ ...buttonStyles, background: '#6123FF' }} autoFocus onClick={() => setPage(1)}>
            Back
          </Button>
        </Box>
        <Box sx={{ padding: '16px' }}>
          <Button
            disabled={isDisabled(values)}
            sx={{ ...buttonStyles, background: !isDisabled(values) && '#6123FF' }}
            autoFocus
            onClick={() => setPage(3)}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

const buttonStyles = {
  borderRadius: '12px',
  fontFamily: 'Plus Jakarta Sans',
  color: '#fff',
  textTransform: 'none',
  border: 'none',
  width: 200,
  '&:hover': {
    background: '#1565c0'
  }
}

function isDisabled(values) {
  const trainingModuleIds = Array.isArray(values?.trainingModuleIds) ? values.trainingModuleIds : []
  const customTrainingModuleIds = Array.isArray(values?.customTrainingModuleIds) ? values.customTrainingModuleIds : []

  return trainingModuleIds.length === 0 && customTrainingModuleIds.length === 0
}
